import React, { useEffect, useState } from "react";
import { getPOInvoice } from "../../../actions/project-management.action";

import Button from 'react-bootstrap/Button';
import { SUPPLIERS, VENDOR_PAYMENT } from "../../../constants/route-paths";
import "./scss/style.scss";
import idx from "idx";
import { resolveProjectType } from "../../projects/utils/resolve-project-type";
import { format } from "date-fns";
import { numberFormat } from "../../../util/currency-formatter";
import { isInlineItem, INLINE_CATALOG_DISPLAY_NAME } from "../../../util/common";
import '../../projects/scss/task.scss'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Table from 'react-bootstrap/Table';
import { getOnlyProjectData } from "../../projects/utils/get-project";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { GSTORVAT } from 'src/util/enums';

function ViewInvoicePurchaseOrder(props) {
  const [invoiceData, setInvoiceData] = useState([]);
  const [items, setItems] = useState([]);
  const [vendorType, setVendorType] = useState("");
  const [projectId, setProjectId] = useState(null);

  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectDetail = {}, project: projectState } = useSelector(state => state)

  useEffect(() => {
    const invoiceId = params.invoiceId;

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");

    if (id && id !== "null") {
      setProjectId(id);
    } else {
      setProjectId(null);
    }
    fetchPOInvoice(invoiceId);

    if (!idx(projectDetail, _ => _.project.res) && id && id !== "null")
      getOnlyProjectData({ projectId: id, dispatch })
  }, []);

  const fetchPOInvoice = async (invoiceId) => {
    let invoice;
    invoice = await dispatch(getPOInvoice(invoiceId)).catch(e => console.log(e));


    const data = {
      poId: idx(invoice, (_) => _.purchaseOrder.id),
      fId: idx(invoice, (_) => _.purchaseOrder.f_id),
      invoiceNo: invoice.invoiceNo,
      amountPaid: invoice.amountPaid,
      retentionAmount: invoice.retentionAmount,
      retentionReleasedAmount: invoice.retentionReleasedAmount,
      invoiceURL: invoice.invoiceURL,
      invoiceClaim: invoice.invoiceClaim,
      invoiceDate: invoice.invoiceDate,
      dueDate: invoice.dueDate,
      approvedAmount: invoice.approvedAmount,
      subTotal: invoice.subTotal,
      taxAmount: invoice.taxAmount,
      progressClaimNumber: invoice.progress_claim_number,
      isCreditInvoice: idx(invoice, _ => _.purchaseOrder.is_credit_invoice) || false,
      receiveCreditAmount: idx(invoice, _ => _.purchaseOrder.receive_credit_amount) || 0,
    };

    const items = idx(invoice, (_) => _.items) || [];

    const vendorType = idx(invoice, (_) => _.purchaseOrder.vendor.type);
    setItems(items);
    setVendorType(vendorType);
    setInvoiceData(data);
  };

  const cancelHandler = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type");
    const id = urlParams.get("id");
    const poId = urlParams.get("poId");

    if (id && type === "project") {
      props.history(`/${SUPPLIERS}/${VENDOR_PAYMENT}?project=${id}`);
    } else if (type && poId) {
      props.history(`/${SUPPLIERS}/${VENDOR_PAYMENT}?type=${type}&poId=${poId}`);
    } else {
      props.history(`/${SUPPLIERS}/${VENDOR_PAYMENT}`);
    }
  };

  const viewProject = () => navigate(`/projects/view/${projectId}`)
  const viewProjectList = () => {
    let type = resolveProjectType(
      idx(projectDetail, _ => _.project.res.projectType) || new URLSearchParams(window.location.search).get("project-type"),
      projectState
    );
    navigate(`/projects?project-type=${type}`);
  }

  return (
    <div className="purchase-order-block" data-cy='vendor-payment-view-container'>
      <h2 className="content-heading text-uppercase">VENDOR PAYMENT VIEW</h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          {new URLSearchParams(window.location.search).get("returnTab") ? (
            <>
              <Breadcrumb.Item onClick={() => props.history('/vendor/vendor-list')} data-cy='vendors-breadcrumb'>VENDORS</Breadcrumb.Item>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='invoices-breadcrumb'>INVOICES</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          ) : projectId ? (
            <>
              <Breadcrumb.Item onClick={viewProjectList} data-cy='projects-breadcrumb'>PROJECTS</Breadcrumb.Item>
              <Breadcrumb.Item onClick={viewProject} data-cy='project-breadcrumb'>{idx(projectDetail, _ => _.project.res.name)}</Breadcrumb.Item>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='vendor-payment-breadcrumb'>VENDOR PAYMENT</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          ) : (
            <>
              <Breadcrumb.Item onClick={cancelHandler} data-cy='vendor-payment-breadcrumb'>VENDOR PAYMENT</Breadcrumb.Item>
              <Breadcrumb.Item active data-cy='view-breadcrumb'>View</Breadcrumb.Item>
            </>
          )}
        </Breadcrumb>
      </div>

      <div className="row">
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='po-no'   >
            <label>PO</label>
            {/* fId is the PO number with project prefix and Suffix if null then default to po Number*/}
            <p>{invoiceData.fId || invoiceData.poId}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-no'>
            <label>Invoice No</label>
            <p>{invoiceData.invoiceNo}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-claim'>
            <label>Invoice Claim</label>
            <p>{numberFormat(invoiceData.invoiceClaim)}</p>
          </div>
        </div>
        {vendorType === "sub-contractor" && (
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy='progress-claim'>
              <label>Progress Claim No</label>
              <p>{invoiceData.progressClaimNumber || '-'}</p>
            </div>
          </div>
        )}
        {vendorType === "Supplier" && (<>
          <div class="col-lg-4 mt-3">
            <div class="view-block" data-cy='sub-total'>
              <label>Sub Total (Ex. {GSTORVAT})</label>
              <p>{numberFormat(invoiceData.subTotal)}</p>
            </div>
          </div>
          <div class="col-lg-4 mt-3">
            <div class="view-block" data-cy='tax-amount'>
              <label>{GSTORVAT}</label>
              <p>{numberFormat(invoiceData.taxAmount)}</p>
            </div>
          </div>
          {invoiceData.isCreditInvoice && (
            <div class="col-lg-4 mt-3">
              <div class="view-block">
                <label>Credit Invoice</label>
                <p>{numberFormat(invoiceData.receiveCreditAmount)}</p>
              </div>
            </div>
          )}
        </>)
        }
        {vendorType === "sub-contractor" && (<div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='approved-amount'>
            <label>Approved Amount</label>
            <p>{numberFormat(invoiceData.approvedAmount)}</p>
          </div>
        </div>)}
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='amount-paid'>
            <label>Amount Paid</label>
            <p>{numberFormat(invoiceData.isCreditInvoice ? 0 : invoiceData.amountPaid)}</p>
          </div>
        </div>
        {vendorType === "sub-contractor" && (
          <>
            <div className="col-lg-4 mt-3">
              <div className="view-block" data-cy='retention-amount'>
                <label>Retention Held</label>
                <p>{numberFormat(invoiceData.retentionAmount)}</p>
              </div>
            </div>
            <div className="col-lg-4 mt-3">
              <div className="view-block" data-cy='retention-released-amount'>
                <label>Retention Released</label>
                <p>{numberFormat(invoiceData.retentionReleasedAmount)}</p>
              </div>
            </div>
          </>
        )}
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='invoice-date'>
            <label>Invoice Date</label>
            <p>{invoiceData && invoiceData.invoiceDate && format(new Date(invoiceData.invoiceDate), "dd/MM/yyyy")}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy='due-date'>
            <label>Due Date</label>
            <p>{invoiceData && invoiceData.dueDate && format(new Date(invoiceData.dueDate), "dd/MM/yyyy")}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block text-left" data-cy='invoice-url'>
            <label>Invoice URL</label>
            <a
              href={invoiceData.invoiceURL}
              rel="noopener noreferrer"
              target="_blank"
              data-cy='invoice-url-link'
            >
              Invoice URL
            </a>
          </div>
        </div>
        <div className="col-12">
          <div className="material-list-block mt-4">
            <div className="table-responsive" data-cy='items-table-container'>
              <Table bordered className="table-create table-material table-material-ch" data-cy='items-table'>
                <thead>
                  <tr>
                    {vendorType === "Supplier" ? (
                      <>
                        <th data-cy='task-header'>Task</th>
                        <th data-cy='catalog-header'>Catalog</th>
                        <th data-cy='items-description-header'>Items Description</th>
                        <th data-cy='category-header'>Category</th>
                        <th data-cy='part-no-header'>Part No</th>
                        <th className="text-right" data-cy='unit-cost-header'>Unit Cost</th>
                        <th data-cy='ordered-quantity-header'>Ordered Quantity</th>
                        <th data-cy='received-quantity-header'>Received  Quantity</th>
                        <th data-cy='previous-inv-header'>Previous Inv</th>
                        <th data-cy='this-inv-header'>This Inv</th>
                        <th data-cy='uom-header'>UoM</th>
                        <th className="text-right" data-cy='total-header'>Total</th>
                      </>
                    ) : (
                      <>
                        <th className="w-auto" data-cy='task-header'>Task</th>
                        <th className="w-auto" data-cy='description-header'>Description</th>
                        <th className="w-auto text-right" data-cy='total-cost-header'>Total Cost</th>
                        <th className="text-right" data-cy='previous-inv-header'>Previous Inv</th>
                        <th className="text-right" data-cy='invoice-claim-header'>Invoice Claim</th>
                        <th className="text-right" data-cy='this-inv-header'>This Inv</th>
                        <th className="text-right" data-cy='total-header'>Total</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {vendorType === "Supplier" ? (
                    <>
                      {(Array.isArray(items) && items.length && items.map((item, index) => (
                        <tr key={index} data-cy='task-row'>
                          <td data-cy='task-name'>{item.taskName}</td>
                          <td data-cy='catalog-name'>{isInlineItem(item) ? INLINE_CATALOG_DISPLAY_NAME : item.category}</td>
                          <td data-cy='items-description-row'>{item.item}</td>
                          <td data-cy='manufacturer-name'>{item.manufacturer}</td>
                          <td data-cy='part-no'>{item.partNo}</td>
                          <td className="text-right">{numberFormat(item.cost)}</td>
                          <td data-cy='ordered-quantity'>{item.qty}</td>
                          <td data-cy='received-quantity'>{item.receivedQty}</td>
                          <td data-cy='previous-inv'>{item.previousInv}</td>
                          <td data-cy='this-inv'>{item.invoicedQty}</td>
                          <td data-cy='uom'>{item.unit}</td>
                          <td className="text-right" data-cy='total'>{numberFormat(item.amountPaid)}</td>
                        </tr>
                      ))) || (
                          <tr>
                            <td colSpan={12} className="text-center" data-cy='no-items-to-show-row'> No Items to Show</td>
                          </tr>
                        )}
                    </>
                  ) : (
                    <>
                      {(Array.isArray(items) && items.length && items.map((item, index) => (
                        <tr key={index} data-cy='task-row'>
                          <td data-cy='task-name'>{item.taskName}</td>
                          <td data-cy='description'>{item.name || '-'}</td>
                          <td className="text-right" data-cy='total-cost'>{numberFormat(item.total)}</td>
                          <td className="text-right" data-cy='previous-inv'>{numberFormat(item.previousInv)}</td>
                          <td className="text-right" data-cy='invoice-claim'>{numberFormat(item.thisInv)}</td>
                          <td className="text-right" data-cy='this-inv'>{numberFormat(item.amountPaid)}</td>
                          <td className="text-right" data-cy='total'>{numberFormat(item.amountPaid)}</td>
                        </tr>
                      ))) || (
                          <tr data-cy='no-items-to-show'>
                            <td colSpan={7} className="text-center" data-cy='no-items-to-show-row'> No Items to Show</td>
                          </tr>
                        )}
                    </>
                  )}
                </tbody>
              </Table>
            </div>

          </div>
        </div>
        <div className="col-12 mt-4 text-end d-flex justify-content-end gap-2">
          <Button className="secondarybtn cancelbtn" onClick={cancelHandler} data-cy='back-btn'>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}
export default ViewInvoicePurchaseOrder;


